import type { NamespaceCountriesTranslation } from '../../i18n-types';

// eslint-disable-next-line @typescript-eslint/naming-convention
const en_countries = {
	AFG: 'Islamic Republic of Afghanistan',
	ALA: 'Åland Islands',
	ALB: 'Albania',
	DZA: 'People’s Democratic Republic of Algeria',
	ASM: 'Territory of American Samoa',
	VIR: 'United States Virgin Islands',
	AND: 'Andorra',
	AGO: 'Republic of Angola',
	AIA: 'Anguilla',
	ATA: 'Antarctica',
	ATG: 'Antigua and Barbuda',
	ARG: 'Argentine Republic',
	ARM: 'Armenia',
	ABW: 'Aruba',
	AUS: 'Commonwealth of Australia',
	AZE: 'Azerbaijan',
	BHS: 'Commonwealth of The Bahamas',
	BHR: 'Kingdom of Bahrain',
	BGD: 'People’s Republic of Bangladesh',
	BRB: 'Barbados',
	BEL: 'Belgium',
	BLZ: 'Belize',
	BLR: 'Republic of Belarus',
	BEN: 'Republic of Benin',
	BMU: 'Bermuda',
	BTN: 'Kingdom of Bhutan',
	BOL: 'Plurinational State of Bolivia',
	BES: 'Bonaire, Sint Eustatius, and Saba',
	BIH: 'Bosnia and Herzegovina',
	BWA: 'Republic of Botswana',
	BVT: 'Bouvet Island',
	BRA: 'Federative Republic of Brazil',
	IOT: 'British Indian Ocean Territory',
	VGB: 'British Virgin Islands',
	BRN: 'State of Brunei Darussalam',
	BGR: 'Bulgaria',
	BFA: 'Burkina Faso',
	BDI: 'Republic of Burundi',
	COK: 'Cook Islands',
	CUW: 'Country of Curaçao',
	TCD: 'Republic of Chad',
	MNE: 'Montenegro',
	CZE: 'Czechia',
	CHN: 'People’s Republic of China',
	DNK: 'Denmark',
	DMA: 'Commonwealth of Dominica',
	DOM: 'Dominican Republic',
	DJI: 'Republic of Djibouti',
	EGY: 'Arab Republic of Egypt',
	ECU: 'Republic of Ecuador',
	ERI: 'State of Eritrea',
	EST: 'Estonia',
	ETH: 'Federal Democratic Republic of Ethiopia',
	FRO: 'Faroe Islands',
	FLK: 'Falkland Islands (Malvinas)',
	FJI: 'Republic of Fiji',
	PHL: 'Republic of the Philippines',
	FIN: 'Finland',
	FRA: 'France',
	GUF: 'French Guiana',
	ATF: 'French Southern and Antarctic Lands',
	PYF: 'French Polynesia',
	GAB: 'Gabonese Republic',
	GMB: 'Republic of The Gambia',
	GHA: 'Republic of Ghana',
	GIB: 'Gibraltar',
	GRD: 'Grenada',
	GRL: 'Greenland',
	GEO: 'Georgia',
	GLP: 'Guadeloupe Region',
	GUM: 'Territory of Guam',
	GTM: 'Republic of Guatemala',
	GGY: 'Bailiwick of Guernsey',
	GIN: 'Republic of Guinea',
	GNB: 'Republic of Guinea-Bissau',
	GUY: 'Cooperative Republic of Guyana',
	HTI: 'Republic of Haiti',
	HMD: 'Heard Island and McDonald Islands',
	HND: 'Republic of Honduras',
	HKG: 'Hong Kong Special Administrative Region of the People’s Republic of China',
	CHL: 'Republic of Chile',
	HRV: 'Croatia',
	IND: 'Republic of India',
	IDN: 'Republic of Indonesia',
	IRQ: 'Republic of Iraq',
	IRN: 'Islamic Republic of Iran',
	IRL: 'Ireland',
	ISL: 'Iceland',
	ITA: 'Italy',
	ISR: 'State of Israel',
	JAM: 'Jamaica',
	JPN: 'Japan',
	YEM: 'Republic of Yemen',
	JEY: 'Bailiwick of Jersey',
	ZAF: 'Republic of South Africa',
	SGS: 'South Georgia and the South Sandwich Islands',
	SSD: 'Republic of South Sudan',
	JOR: 'Hashemite Kingdom of Jordan',
	CYM: 'Cayman Islands',
	KHM: 'Kingdom of Cambodia',
	CMR: 'Republic of Cameroon',
	CAN: 'Canada',
	CPV: 'Republic of Cape Verde',
	QAT: 'State of Qatar',
	KAZ: 'Republic of Kazakhstan',
	KEN: 'Republic of Kenya',
	KIR: 'Republic of Kiribati',
	CCK: 'Cocos (Keeling) Islands Territory',
	COL: 'Republic of Colombia',
	COM: 'Union of the Comoros',
	COD: 'Democratic Republic of the Congo',
	COG: 'Republic of the Congo',
	PRK: 'Democratic People’s Republic of Korea',
	KOR: 'Republic of Korea',
	KSV: 'Kosovo',
	CRI: 'Republic of Costa Rica',
	CUB: 'Republic of Cuba',
	KWT: 'State of Kuwait',
	CYP: 'Cyprus',
	KGZ: 'Kyrgyz Republic',
	LAO: 'Lao People’s Democratic Republic',
	LSO: 'Kingdom of Lesotho',
	LBN: 'Lebanese Republic',
	LBR: 'Republic of Liberia',
	LBY: 'State of Libya',
	LIE: 'Liechtenstein',
	LTU: 'Lithuania',
	LVA: 'Latvia',
	LUX: 'Luxembourg',
	MAC: 'Macao Special Administrative Region of the People’s Republic of China',
	MDG: 'Republic of Madagascar',
	HUN: 'Hungary',
	MYS: 'Malaysia',
	MWI: 'Republic of Malawi',
	MDV: 'Republic of Maldives',
	MLI: 'Republic of Mali',
	MLT: 'Malta',
	IMN: 'Isle of Man',
	MAR: 'Kingdom of Morocco',
	MHL: 'Republic of the Marshall Islands',
	MTQ: 'Martinique',
	MUS: 'Republic of Mauritius',
	MRT: 'Islamic Republic of Mauritania',
	MYT: 'Department of Mayotte',
	UMI: 'United States Minor Outlying Islands',
	MEX: 'United Mexican States',
	FSM: 'Federated States of Micronesia',
	MDA: 'Moldova',
	MCO: 'Monaco',
	MNG: 'Mongolia',
	MSR: 'Montserrat',
	MOZ: 'Republic of Mozambique',
	MMR: 'Republic of the Union of Myanmar',
	NAM: 'Republic of Namibia',
	NRU: 'Republic of Nauru',
	DEU: 'Germany',
	NPL: 'Federal Democratic Republic of Nepal',
	NER: 'Republic of Niger',
	NGA: 'Federal Republic of Nigeria',
	NIC: 'Republic of Nicaragua',
	NIU: 'Niue',
	NLD: 'Netherlands',
	NFK: 'Norfolk Island Territory',
	NOR: 'Norway',
	NCL: 'New Caledonia',
	NZL: 'New Zealand',
	OMN: 'Sultanate of Oman',
	PAK: 'Islamic Republic of Pakistan',
	PLW: 'Republic of Palau',
	PSE: 'Palestinian Territories',
	PAN: 'Republic of Panama',
	PNG: 'Independent State of Papua New Guinea',
	PRY: 'Republic of Paraguay',
	PER: 'Republic of Peru',
	PCN: 'Pitcairn Islands',
	CIV: 'Republic of Côte d’Ivoire',
	POL: 'Poland',
	PRI: 'Commonwealth of Puerto Rico',
	PRT: 'Portugal',
	AUT: 'Austria',
	REU: 'Réunion Region',
	GNQ: 'Republic of Equatorial Guinea',
	ROU: 'Romania',
	RUS: 'Russian Federation',
	RWA: 'Republic of Rwanda',
	GRC: 'Greece',
	SPM: 'Territory of Saint Pierre and Miquelon',
	SLV: 'Republic of El Salvador',
	WSM: 'Independent State of Samoa',
	SMR: 'San Marino',
	SAU: 'Kingdom of Saudi Arabia',

	SEN: 'Republic of Senegal',
	MKD: 'North Macedonia',

	MNP: 'Commonwealth of the Northern Mariana Islands',
	SYC: 'Republic of Seychelles',
	SLE: 'Republic of Sierra Leone',
	SGP: 'Republic of Singapore',
	SVK: 'Slovakia',
	SVN: 'Slovenia',
	SOM: 'Federal Republic of Somalia',
	ARE: 'United Arab Emirates',
	USA: 'United States of America',
	SRB: 'Serbia',
	CAF: 'Central African Republic',
	SDN: 'Republic of the Sudan',
	SUR: 'Republic of Suriname',
	SHN: 'Saint Helena, Ascension and Tristan da Cunha',
	LCA: 'Saint Lucia',
	BLM: 'Collectivity of Saint Barthélemy',
	KNA: 'Federation of Saint Kitts and Nevis',
	MAF: 'Collectivity of Saint Martin',
	SXM: 'Saint Martin (Dutch part)',
	STP: 'Democratic Republic of São Tomé and Príncipe',
	VCT: 'Saint Vincent and the Grenadines',
	SWZ: 'Kingdom of Eswatini',
	SYR: 'Syrian Arab Republic',
	SLB: 'Solomon Islands',
	ESP: 'Spain',
	SJM: 'Svalbard and Jan Mayen',
	LKA: 'Democratic Socialist Republic of Sri Lanka',
	SWE: 'Sweden',
	CHE: 'Switzerland',
	TJK: 'Republic of Tajikistan',
	TZA: 'United Republic of Tanzania',
	THA: 'Kingdom of Thailand',
	TWN: 'Taiwan',
	TGO: 'Togolese Republic',
	TKL: 'Tokelau',
	TON: 'Kingdom of Tonga',
	TTO: 'Republic of Trinidad and Tobago',
	TUN: 'Tunisian Republic',
	TUR: 'Turkey',
	TKM: 'Turkmenistan',
	TCA: 'Turks and Caicos Islands',
	TUV: 'Tuvalu',
	UGA: 'Republic of Uganda',
	UKR: 'Ukraine',
	URY: 'Eastern Republic of Uruguay',
	UZB: 'Republic of Uzbekistan',
	CXR: 'Christmas Island Territory',
	VUT: 'Republic of Vanuatu',
	VAT: 'Vatican City State',
	GBR: 'United Kingdom',
	VEN: 'Bolivarian Republic of Venezuela',
	VNM: 'Socialist Republic of Vietnam',
	TLS: 'Democratic Republic of East Timor',
	WLF: 'Territory of Wallis and Futuna',
	ZMB: 'Republic of Zambia',
	ESH: 'Sahrawi Arab Democratic Republic',
	ZWE: 'Republic of Zimbabwe',
	UNKNOWN: 'Unknown country',
} satisfies NamespaceCountriesTranslation;

export default en_countries;
